import { StateCreator } from 'zustand';
import { IViewDefinition } from './viewDefinition.interface';

export const viewDefinitionSlice: StateCreator<IViewDefinition> = (set) => ({
  viewDefinition: {},
  setViewDefinition(data: Record<string, any>) {
    set(() => ({ viewDefinition: data }));
  },
});
